import { useEffect, useState, useCallback } from 'react';
import cn from 'classnames';
import styles from 'components/Image/Image.scss';

export const ImageComponent = ({ className, src, placeholder, alt, fit = 'cover', ratio }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleMainImageLoad = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  useEffect(() => {
    const mainImg = new Image();
    mainImg.onload = handleMainImageLoad;
    mainImg.src = src;

    return () => setIsImageLoaded(false);
  }, [src, handleMainImageLoad]);

  const resolvedSrc = isImageLoaded ? src : placeholder;

  return (
    <div className={cn(styles.wrapper, className)} style={ratio ? { aspectRatio: ratio } : undefined}>
      {fit === 'contain' && <img aria-hidden='true' alt='' className={styles.backdrop} src={resolvedSrc} loading='lazy' />}
      <img
        alt={alt}
        className={cn(styles.image, {
          [styles.placeholder]: placeholder && !isImageLoaded,
        })}
        src={resolvedSrc}
        loading='lazy'
        style={{ objectFit: fit }}
      />
    </div>
  );
};
